export interface AuthConfig {
    cognitoDomain: string;
    region: string;
    redirectSignIn: string;
    identityPoolId: string;
    userPoolId: string;
    userPoolClientId: string;
  }
  
export interface UserIdentity {
    username: string;
    accessToken: string;
  }
  
export enum ConfiguredDomain {
    PROD = "prod.sentinel.aft.amazon.dev",
    BETA = "beta.sentinel.aft.amazon.dev",
    ALPHA = "alpha.sentinel.aft.amazon.dev",
    SAURAVTR = "sauravtr-devdesk.aka.corp.amazon.com",
    PRASPWR = "praspwr-clouddesk.aka.corp.amazon.com",
    ARVELE = "dev-desk-arvele.aka.corp.amazon.com",
    WANBOJUN = "wanbojun-clouddesk.aka.corp.amazon.com",
    JICINDY = "jicindy-clouddesk.aka.corp.amazon.com",
    JICINDY_PS = "jicindy-mid.personalstack.alpha.sentinel.aft.amazon.dev",
    MIGSRRA = "migsrra-clouddesk.aka.corp.amazon.com",
  }